import {subclass, property} from "@arcgis/core/core/accessorSupport/decorators";

import Widget from "@arcgis/core/widgets/Widget";

import { messageBundle, tsx } from "@arcgis/core/widgets/support/widget";
import {VNode} from 'src/interfaces/interfaces';

import "./FeaturedSidebar.scss";

import AppT9N from "../../../t9n/App/App.json";
import {substitute} from '@arcgis/core/intl';

import NewBlogPic from "../../../../public/assets/featuredArticle/instant-apps-what-is-new.png";
import BlogPic from "../../../../public/assets/featuredArticle/instant-apps-blog.jpg";
import NavBarViewModel from "src/app/ui/NavBar/NavBarViewModel";

import SidebarTilePic from "../../../../public/assets/featuredArticle/articleTilePics/SidebarArticle.png"
import ChartViewerTilePic from "../../../../public/assets/featuredArticle/articleTilePics/ChartViewerArticle.png"
import {keyboardAccessibleHelper} from "../../utils/appUtils";

interface IBlogTile {
  imgRef: string;
  headerTitle: string;
  descText: string;
  linkUrl: string; 
  linkText: string;
}

interface IArticleTile {
  id: string;
  imgRef: string;
  headerTitle: string;
  descText: string;
}

export const PRODUCT_NAME = "ArcGIS Instant Apps";

@subclass("app.widgets.Sidebar.FeaturedSidebar")
export default class FeaturedSidebar extends (Widget) {

  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  @property()
  navbarVM: NavBarViewModel;

  //--------------------------------------------------------------------------
  //
  //  Public Methods
  //
  //--------------------------------------------------------------------------

  constructor(args){
    super(args);
  }

  render() {
    const { 
      whatsNewText, whatsNewDesc, whatsNewLink,
      sidebarArticle, sidebarArticleDesc,
      chartViewerArticle, chartViewerArticleDesc,
      blogText, blogDesc, blogLink
    } = this.appMessages.featuredTab;
    return (
      <div class="featured-sidebar">

        <div>
          {this._renderArticleTile({
            id: "sidebar",
            imgRef: SidebarTilePic,
            headerTitle: sidebarArticle,
            descText: sidebarArticleDesc
          })}
          {this._renderArticleTile({
            id: "chartViewer",
            imgRef: ChartViewerTilePic,
            headerTitle: chartViewerArticle,
            descText: chartViewerArticleDesc
          })}
        </div>


        <hr />


        {this._renderBlogTile({
          imgRef: NewBlogPic, 
          headerTitle: substitute(whatsNewText, { productName: PRODUCT_NAME }),
          descText: substitute(whatsNewDesc, { productName: PRODUCT_NAME }),
          linkUrl: "https://links.esri.com/agol-help/whats-new-instant-apps",
          linkText: whatsNewLink 
        })}
        {this._renderBlogTile({ 
          imgRef: BlogPic, 
          headerTitle: substitute(blogText, { productName: PRODUCT_NAME }),
          descText: substitute(blogDesc, { productName: PRODUCT_NAME }),
          linkUrl: "https://www.esri.com/arcgis-blog/?s=#&products=instant-apps",
          linkText: substitute(blogLink, { productName: PRODUCT_NAME })
        })}
      </div>
      );
  }

  //--------------------------------------------------------------------------
  //
  //  Private Methods
  //
  //--------------------------------------------------------------------------
  
  private _renderArticleTile(articleTile: IArticleTile): VNode {
    const {imgRef, headerTitle, descText, id} = articleTile;
    return (
      <div class={this.classes(
          "article-tile",
          // Note: Commented out "currently selected" article hightlight for now. Maybe use later
          // this.navbarVM._featuredArticleStateRouter === id ? "article-tile--selected" : null
        )}
        onclick={this._handleCarouselSelection.bind(this, id)}
        onkeydown={(e: KeyboardEvent)=>{
          
          if(e.code === "Space"){ // stop space from scrolling the sidebar down
            e.preventDefault();
          }

          keyboardAccessibleHelper(
            this._handleCarouselSelection.bind(this, id), 
            e
          )}
        }
        tabindex="0"
      >
        <img src={imgRef} alt=""/>
        <div class="article-tile-info">
          <header class="article-header-text">
            {headerTitle}
          </header>
          <p>{descText}</p>
        </div>
      </div>
    )
  }

  private _renderBlogTile(blogTile: IBlogTile): VNode {
    const {imgRef, headerTitle, descText, linkUrl, linkText} = blogTile; 
    return (
      <div class="blog-tile">
        <img src={imgRef} alt=""/>
        <header class="blogHeaderText">{headerTitle}</header>
        <p>{descText}</p>
        <calcite-link href={linkUrl} target="_blank" icon-end="launch">{linkText}</calcite-link>
      </div>
    )
  }

  private _handleCarouselSelection(id: any): void {
    this.navbarVM._featuredArticleStateRouter = id;
  }

}